import {AfterViewInit, Directive, ElementRef, OnInit} from '@angular/core';

/**
 * @description
 * Rc scroll to element directive - on init, scroll body scroll to element
 *
 * @example
 * <div lib-rc-scroll-to>hello world</div>
 *
 */
@Directive({
  selector: '[lib-rc-scroll-to]'
})
export class RcScrollToDirective implements AfterViewInit {

  constructor(private element: ElementRef) { }

  ngAfterViewInit() {
    this.element.nativeElement.scrollIntoView();
  }

}
